<template>
  <transition
    :css="animation.css"
    :name="animation.name"
    :mode="animation.mode"
    @enter="animation.enter"
    @leave="animation.leave"
    appear
  >
    <div
      v-if="show"
      class="c-template c-template--cookie"
      :data-theme="theme"
    >
      <slot
        v-for="slot in slots"
        :name="slot"
      />
    </div>
  </transition>
</template>

<script>
export default {
  name: 'CookieTemplate',

  props: {
    theme: {
      type: String,
      required: false,
      default: 'default',
    },
    slots: {
      type: Array,
      required: false,
      default() {
        return ['content', 'button'];
      },
    },
    animation: {
      type: Object,
      required: false,
      default() {
        return {
          css: false,
          name: '',
          mode: 'in-out',
          enter: (element, done) => { done(); },
          leave: (element, done) => { done(); },
        };
      },
    },
  },

  data() {
    return {
      show: true,
    };
  },

  created() {
    if (localStorage.getItem('cookie:accepted')) {
      this.show = false;
    }
    this.$on('cookie-accepted', () => { this.show = false; });
  },
};
</script>

<style lang="scss" scoped>
@import './style/index';

.c-template.c-template--cookie {
  box-sizing: border-box;
  position: fixed;
  width: 100%;
  left: 0;

  font-size: font-size(xs);

  @include mq($from: ipadP) {
    width: 600px;
    left: 50%;
    margin-left: -300px;
    font-size: font-size(xxs);
  }

  @include mq($until: ipadP) {
    bottom: unset;
    top: 70px;
    line-height: 1.5;
    text-align: center;
    flex-flow: column wrap;
  }

  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-flow: row wrap;

  bottom: 0;
  padding: 20px 40px;

  font-family: $font-family-base;
  border: 0;

  z-index: 100;

  span {
    font-family: $font-family-base;
  }
}
</style>
